<template xmlns="http://www.w3.org/1999/html">
  <div class="serialInputContent row">
    <div class="col-12 inputTitle">
        <p>Syötä laitteen sarjanumero</p>
    </div>
      <div class="col-12 col-lg-6">
        <form @submit.prevent="submit">
          <div class="form-group">
            <div class="input-group-append">
              <input class="form-control" id="serialInput" aria-describedby="serialInputHelp" v-model="serialNumber" placeholder="">
            </div>
            <small id="serialInputHelp" class="form-text text-muted">Käytä <b><i>AX18E013810</i></b> tai <b><i>Test</i></b> testidataa varten</small>
          </div>
          <div class="col-sm-12 errorBox">
            <div class="error" v-if="error.length > 0">
              <p>{{ error }}</p>
            </div>
          </div>
          <button type="submit" class="btn btn-primary" :disabled=searchButtonDisabled>HAE</button>
        </form>
      </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                serialNumber: '',
                error: '',
            }
        },
        mounted() {
          if(this.$cookies.isKey('lastDeviceSerial')) {
            this.serialNumber = this.$cookies.get('lastDeviceSerial');
          }
        },
        methods: {
            submit() {
                if (this.serialNumber.length <= 5) {
                  this.GetCPRData("Test", true, false);
                } else{
                  this.GetCPRData(this.serialNumber, false, false);
                }
            },
            GetCPRData(serial, mock, forceLoading){
              this.serialNumber = serial.trim();
              this.$emit('setLoading', true);
              this.$emit('setLoadingTitle', "Haetaan tietoja...");
              this.error = '';
              const url = mock ? this.$api_url + "cases/latest/test/cpr?mock=true" : this.$api_url + "cases/latest/"+ this.serialNumber + "/cpr";
              this.$http.get(url)
                .then(res => {
                  this.$cookies.set('lastDeviceSerial',serial);
                  this.$router.push('cpr-results');
                  this.$store.commit('setDeviceSerial', serial);
                  this.$store.commit('cprDataChanged', res.data);
                  this.$emit('setLoading', false);
                })
                .catch(err => {
                  this.$emit('setLoading', false);
                  this.OnError(err.response);
                });
            },
            OnError(error){
              console.log(JSON.stringify(error))
              this.error = error.data;
              this.cprResponse = null;
            }
        },
      computed: {
        searchButtonDisabled() {
          return this.serialNumber.length < 3;
        }
      }
    }
</script>

<style>
  .inputTitle{
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 29px;
    padding-bottom: 5vh;
  }
  .errorBox{
    min-height: 30vh;
  }
  .error {
    color: red;
  }

  input{
    text-align: center;
    border-radius: 30px !important;
    min-height: 41px;
  }

  .btn-primary {
    border-radius: 56px;
    min-width: 150px;
    min-height: 50px;
    font-size: 18px;
    -webkit-box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75);
  }

  .btn-primary:disabled {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    background-color: #AAAAAA;
    border-color: #AAAAAA;
  }

</style>



// WEBPACK FOOTER //
// src/components/InputSerialNumber.vue